export const baseURL = "https://poll-app-node.herokuapp.com";
